// Datos que escriben los usuarios (fotos de perfil, links de eventos, etc.)
// pueden llegar a Firestore sin pasar por los formularios de la app, porque
// cualquiera puede escribir su propio documento llamando a Firestore directo.
// Antes de usarlos como link o dentro de HTML armado a mano hay que
// validarlos acá.

// Devuelve la URL solo si es http(s); si no (javascript:, data:, texto
// cualquiera), null. Sirve para href/src.
export const safeHttpUrl = (value) => {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
};

// Abre en otra pestaña una URL escrita por otro usuario. Un javascript: pasado
// directo a window.open corre con la sesión de quien hace clic.
export const openSafeUrl = (value) => {
  const url = safeHttpUrl(value);
  if (url) window.open(url, "_blank", "noopener");
};

// Escapa texto para meterlo en un string de HTML (p. ej. el html de un
// L.DivIcon de Leaflet, que no pasa por React y no se escapa solo).
export const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

// Sitio web que el usuario escribe a mano en su perfil ("misitio.com",
// "www.misitio.com/tienda"): se le agrega https:// si no tiene protocolo.
// Devuelve la URL normalizada o null si no es un sitio válido.
export const normalizeWebsite = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  const url = safeHttpUrl(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`);
  if (!url) return null;
  return new URL(url).hostname.includes(".") ? url : null;
};

// Cómo se muestra el sitio: sin protocolo, sin "www." ni "/" final.
export const websiteLabel = (url) =>
  String(url).replace(/^https?:\/\//i, "").replace(/^www\./i, "").replace(/\/$/, "");
